import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Message } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class MsgService {

    show = new Subject<{message: Message, position: string}>();

    showMsg(severity, title, content, sticky = false, position = 'top-right') {
        const msg: Message = {
            severity: severity,
            summary: title,
            detail: content,
            life: 8000,
            sticky: sticky
        };
        this.show.next({message: msg, position: position});
    }
}

export enum MsgSeverities {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warn',
    ERROR = 'error'
}